export const coverageConstants = {
    SUCCESS: 'COVERAGE_SUCCESS',
    SUCCESS_ADMIN: 'COVERAGE_ADMIN_SUCCESS',
    ERROR: 'COVERAGE_ERROR',
    FETCHING: 'COVERAGE_FETCHING',
    FETCHING_ADMIN: 'COVERAGE_ADMIN_FETCHING',
};
